<template>
    <div class="cart">
    </div>
</template>

<script>
import { EventBus } from '../../eventBus'

export default {
    name: "Cart",
    components: {

        },
    data () {
        return {
           cart: []
        }
    },
    methods: {
        addToCompare(item){
            if (this.compareList.length !==0){
                if (this.compareList.includes(item)){
                    console.log('already in the list')
                }else {this.compareList.push(item);
                }
            }else {
                this.compareList.push(item);
            }
        },
        removeFromCompare(index){
            console.log(index+ ' removed')
            this.compareList.splice(index, 1)
        }
    },
    mounted(){
        EventBus.$on('addtoCompare', (item) => {
            this.addToCompare(item)        
        })
    }
}
</script>

<style scoped>
td a {
    color:#1997c6 !important;
}
.compare {
    height: 100%;
    overflow: auto;
    /* border: 1px solid white; */
}
.btn-reset {
    background: transparent;
    border: none;
    margin-right: 0px;
    margin-left: -3px;
    font-weight: unset;
    font-size: 10pt;
    padding-top: 2px;
    color: rgb(178, 179, 180) !important;
    overflow: hidden;
}
.btn-reset:hover {
    font-weight: bold;
    color: #3498DB;
}

</style>

